import React from "react";
import { useStore } from "src/store";
import { CustomLink, Spacer } from "../sidebar/contents/dynamic.components";

const TradeMark = ({}) => {
  const { closeOverlay } = useStore();
  return (
    <>
      <div
        className="c-cytiva__trademark-section"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="c-cytiva__trademark-top">
          <img
            className="c-cytiva__trademark-top__logo"
            src="favicon.ico"
            width="40"
            alt="Cytiva logo"
          />
          <button
            className="c-cytiva__trademark-top__close"
            onClick={closeOverlay}
          >
            X
          </button>
        </div>
        <p className="c-cytiva__trademark-text">
          Cytiva and the Drop logo are trademarks of Life Sciences IP Holdings
          Corporation or an affiliate doing business as Cytiva.
          <Spacer />
          Amersham, Cy, and ImageQuant are trademarks of Global Life Sciences
          Solutions USA LLC or an affiliate doing business as Cytiva.
          <Spacer />
          Coomassie is a trademark of Thermo Fisher Scientific. Windows is a
          trademark of Microsoft Corporation. Any other third-party trademarks
          are the property of their respective owners.
          <Spacer />
          © 2022 Cytiva.
          <Spacer />
          For local office contact information, visit:{" "}
          <a
            className="c-cytiva__trademark-text"
            style={{ textDecoration: "none" }}
            href="https://cytiva.com/contact"
            target="_blank"
          >
            cytiva.com/contact
          </a>
          <br />
          CY28708-XXJun27-AM
        </p>
      </div>
    </>
  );
};

export default TradeMark;
